//create a hook which extracts the UTM parameters from the URL and returns as an object
// UTM parameters comes through the queryParams
// posssible UTM parameters are utm_source, utm_medium, utm_campaign

import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { setProspectLead, setRoCode } from "../../store/actions/appConfig";
import { DEFAULT_REFERRAL_NAME } from "../../constants";

export const useFindUTMParameters = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const searchParams = new URLSearchParams(location.search);
  const utmParameters = {
    productName: searchParams.get("product-name") || DEFAULT_REFERRAL_NAME,
    utm_source: searchParams.get("utm_source"),
    utm_medium: searchParams.get("utm_medium"),
    utm_campaign: searchParams.get("utm_campaign"),
    utm_content: searchParams.get("utm_content")
  };

  const roCode = searchParams.get("rocode") || "";
  useEffect(() => {
    dispatch(setRoCode(roCode));
  }, [dispatch, roCode]);

  useEffect(() => {
    dispatch(setProspectLead(utmParameters));
  }, [dispatch, utmParameters]);
};
